import React from "react";
import { Row, Col, Label } from "reactstrap";

const ViewOfferAttributeDetails = ({ attributeBasedList }) => {
  return (
    <>
      {attributeBasedList?.length === 0 ? (
        <div className="text-center mt-4 fw-semibold">
          No Attribute Based Details
        </div>
      ) : (
        attributeBasedList?.map((detail, detailIndex) => (
          <div
            key={detailIndex}
            className="border-top border-opacity-50 rounded-0 mb-3"
          >
            <Row className="mt-4">
              <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                <Label className="fw-bold">Rule ID</Label>
                <p>{detail?.ruleId ? detail?.ruleId : "-"}</p>
              </Col>
              <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                <Label className="fw-bold">Name</Label>
                <p>{detail?.name ? detail?.name : "-"}</p>
              </Col>
              <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                <Label className="fw-bold">Logical Operator</Label>
                <p>
                  {detail?.logicalOperator
                    ? detail?.logicalOperator?.label
                    : "-"}
                </p>
              </Col>
            </Row>

            <Col className="">
              <div className="position-relative mx-n3 mb-1">
                <div className="pb-2 px-3">
                  <Label className="card-title mb-0">Conditions</Label>
                </div>
              </div>
              <Row className="border-bottom mb-3">
                <Col lg={3} md={6}>
                  <Label className="fw-bold">Attribute Name</Label>
                </Col>
                <Col lg={3} md={6}>
                  <Label className="fw-bold">Value</Label>
                </Col>
                <Col lg={3} md={6}>
                  <Label className="fw-bold">Operator</Label>
                </Col>
              </Row>
              {detail?.conditions &&
                detail?.conditions?.length > 0 &&
                detail?.conditions?.map((condition, conditionIndex) => (
                  <Row key={conditionIndex}>
                    <Col lg={3} md={6}>
                      <p>
                        {condition?.attributeName
                          ? condition?.attributeName?.label
                          : "-"}
                      </p>
                    </Col>
                    <Col lg={3} md={6}>
                      <p>{(condition?.value === null || condition?.value === undefined || condition?.value?.toString().trim() === "") ? "-" : condition?.value}</p>
                    </Col>
                    <Col lg={3} md={6}>
                      <p>
                        {condition?.operator ? condition?.operator?.label : "-"}
                      </p>
                    </Col>
                  </Row>
                ))}
            </Col>
          </div>
        ))
      )}
    </>
  );
};

export default ViewOfferAttributeDetails;
